
import gsap from "gsap";

export default function initFooterGridCircles() {
  let isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const footer = document.querySelector('.footer');
  const grid = footer.querySelector('[data-footer-grid]');
  let magneticThrottle = null;
  const circles = [];
  if(!grid) return;

  function getComputedCssVarPx(varName) {
    const el = document.createElement("div");
    el.style.position = "absolute";
    el.style.visibility = "hidden";
    el.style.width = `var(${varName})`;
    document.body.appendChild(el);

    const px = el.offsetWidth;

    el.remove();
    return px;
  }

  function resetMagnetic(state) {
    if (isTouchDevice) return;
    
    circles.forEach((circle) => {
      gsap.to(circle, {
        x: 0,
        y: 0,
        duration: 0.3,
        ease: "power2.out",
        overwrite: "auto"
      });
    });
  }

  function magneticMove(event) {
    if (isTouchDevice || document.documentElement.classList.contains('no-motion') || magneticThrottle) return;
    magneticThrottle = setTimeout(() => {
      magneticThrottle = null;
      
      const rect = grid.getBoundingClientRect();
      
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      
      const { distanceFactor, offsetFactor, duration, ease } = {
      enabled: true,
      distanceFactor: 1.2,
      offsetFactor: 0.0325,
      duration: 0.6,
      ease: "power2.out"
    };
      const circleSizePx = getComputedCssVarPx('--circle-size');
      
      const maxDistance = circleSizePx * 5 * distanceFactor;
      const maxOffset = circleSizePx * offsetFactor * 3;
      
      circles.forEach((circle) => {
        const circleRect = circle.getBoundingClientRect();
        const cx = circleRect.left + circleRect.width / 2 - rect.left;
        const cy = circleRect.top + circleRect.height / 2 - rect.top;
        
        const dx = cx - mouseX;
        const dy = cy - mouseY;
        const dist = Math.sqrt(dx * dx + dy * dy);
        
        if (dist > maxDistance) {
          gsap.to(circle, {
            x: 0,
            y: 0,
            duration: duration * 0.5,
            ease: "power2.out",
            overwrite: "auto"
          });
          return;
        }
        
        const force = (maxDistance - dist) / maxDistance;
        const normX = dx / dist;
        const normY = dy / dist;
        
        const offsetX = normX * force * maxOffset;
        const offsetY = normY * force * maxOffset;
        
        gsap.to(circle, {
          x: offsetX,
          y: offsetY,
          duration,
          ease,
          overwrite: "auto"
        });
      });
    }, 16);
  }

  for (let i = 0; i < 7; i++) {
    const row = document.createElement('div');
    row.classList.add('row-circles');

    for (let j = 0; j < 16; j++) {
      const circle = document.createElement('div');
      circle.classList.add('circle');
      grid.append(circle);
      circles.push(circle);
    }
  }

  footer.addEventListener('mousemove', magneticMove);
  footer.addEventListener('mouseleave', resetMagnetic);

}